// eslint-disable-next-line no-redeclare
/* global Worker */
import { doHidePopup, doShowPopup } from 'Store/actions/popup'
import { actionTypes as sessionActionTypes } from 'Store/actions/session'

// Session configuration
const SESSION_CONFIG = {
  ANON: {
    duration: 3600 - 5, // 1 hour - 5 seconds for possible latency
    extendThreshold: 300 // 5 minutes before expiration
  },
  PORTAL: {
    duration: 300 - 5, // 5 minutes - 5 seconds for possible latency
    extendThreshold: 60 // 1 minute before expiration
  }
}

const EXCLUDED_ROUTE_PATHS = [
  process.env.PATH_LOGIN,
  process.env.REDIRECT_PATH_LOGIN_APP,
  /^\/login-mos\/.+/,
  /^\/courtesy\/.+/,
  /^\/support-pre-login\/.+/,
  /^\/mobilesso\/.+/
  // /^\/registration\/.+/,
  // /^\/registration-nb\/.+/,
  // /^\/recovery-credential\/.+/
]

const ANON_PATHS = [
  /^\/registration\/.+/,
  /^\/registration-nb\/.+/,
  /^\/recovery-credential\/.+/
]

let worker = null
const SESSION_POPUP_KEYS = ['EXTEND_SESSION', 'EXPIRED_SESSION']

function createWorkerScript () {
  return `
    let seconds;
    let endTime;
    let timerId;
    let sessionType = 'PORTAL';
    let sessionConfig = {};

    onmessage = function(e) {
      const { type, path, SESSION_CONFIG, ANON_PATHS } = e.data;

      if (type === 'start') {
        sessionConfig = SESSION_CONFIG;
        
        // Convert string patterns back to RegExp objects
        const anonPatterns = ANON_PATHS.map(pattern => 
          typeof pattern === 'string' ? pattern : new RegExp(pattern.source, pattern.flags)
        );
        
        const isAnonPath = anonPatterns.some(pattern => 
          typeof pattern === 'string' ? pattern === path : pattern.test(path)
        );
        
        sessionType = isAnonPath ? 'ANON' : 'PORTAL';
        const config = sessionConfig[sessionType];
        seconds = config.duration;
        endTime = Date.now() + seconds * 1000;
        clearInterval(timerId);

        timerId = setInterval(() => {
          let remainingSeconds = Math.round((endTime - Date.now()) / 1000);

          if (remainingSeconds <= 0) {
            clearInterval(timerId);
            postMessage({ type: 'action', value: 'EXPIRED_SESSION', sessionType });
          } else if (remainingSeconds === config.extendThreshold) {
            postMessage({ type: 'action', value: 'EXTEND_SESSION', sessionType });
          }

          postMessage({ type: 'seconds', value: remainingSeconds, sessionType });
        }, 1000);
      } else if (type === 'stop') {
        clearInterval(timerId);
      }
    };
  `
}

function initializeWorker (store) {
  if (worker) {
    worker.terminate()
  }

  const blob = new Blob([createWorkerScript()])
  const url = URL.createObjectURL(blob)
  worker = new Worker(url)

  worker.onmessage = function (e) {
    const { type, value, sessionType } = e.data

    if (type === 'seconds') {
      // console.log('seconds', value, 'sessionType', sessionType)
    } else if (type === 'action') {
      // console.log('action', value, 'sessionType', sessionType)
      handleWorkerAction(store, value, sessionType)
    }
  }
}

function handleWorkerAction (store, action, sessionType = 'PORTAL') {
  if (action === 'EXTEND_SESSION') {
    store.dispatch(doShowPopup('EXTEND_SESSION', { sessionType }))
  } else if (action === 'EXPIRED_SESSION') {
    store.dispatch(doShowPopup('EXPIRED_SESSION', { sessionType }))
  }
}

export const sessionTimer = store => next => action => {
  const currentPath = window.location.pathname
  const isExcludedRoutePath = EXCLUDED_ROUTE_PATHS.filter(path => path !== undefined).some(path =>
    typeof path === 'string' ? path === currentPath : path.test(currentPath)
  )

  function startSessionTimer () {
    if (!worker) {
      initializeWorker(store)
    }
    worker.postMessage({ type: 'stop' })
    worker.postMessage({
      type: 'start',
      path: currentPath,
      SESSION_CONFIG,
      ANON_PATHS: ANON_PATHS.map(pattern =>
        typeof pattern === 'string' ? pattern : { source: pattern.source, flags: pattern.flags }
      )
    })
  }
  function stopSessionTimer () {
    if (worker) {
      worker.postMessage({ type: 'stop' })
    }
  }

  const hasSession = Boolean(window.sessionStorage.getItem('jwe') || window.sessionStorage.getItem('anon_jwe'))
  const isSessionActivity = action.type === sessionActionTypes.DO_SESSION_ACTIVITY

  if (isSessionActivity && hasSession) {
    if (isExcludedRoutePath) {
      stopSessionTimer()
    } else {
      startSessionTimer()
      if (SESSION_POPUP_KEYS.includes(store.getState().popup?.popupKey)) {
        store.dispatch(doHidePopup())
      }
    }
  }

  if (/_SUCCESS/i.test(action.type)) {
    if (!(action.payload && action.payload.excludeFromTimer)) {
      if (!isExcludedRoutePath) {
        startSessionTimer()
      } else {
        stopSessionTimer()
      }
    }
  }

  if (/_FAILURE/i.test(action.type)) {
    const isError401 = action.error && action.error.status === 401
    // const isError409 = action.error && action.error.status === Number(process.env.SCA_CODE)

    if (!(action.payload && action.payload.excludeFromTimer)) {
      if (isExcludedRoutePath || isError401) {
        stopSessionTimer()
      } else {
        startSessionTimer()
      }
    }
  }

  if (/stop_session_timer/.test(action.type) || !hasSession) {
    stopSessionTimer()
  }

  return next(action)
}
